import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Clouds = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M10.2715 14.4748C11.3194 10.6639 14.7902 8 18.7701 8H20C24.7363 8 28.5758 11.8395 28.5758 16.5758V17.6923H30.3462C34.021 17.6923 37 20.6713 37 24.3462C37 28.021 34.021 31 30.3462 31H11.2692C6.70226 31 3 27.2977 3 22.7308V22.1889C3 18.0742 6.21597 14.7107 10.2715 14.4748ZM18.7701 10C15.6057 10 12.8576 12.1782 12.1352 15.2591L12.1103 15.3654C11.9597 16.0075 11.3869 16.4615 10.7273 16.4615C7.56421 16.4615 5 19.0258 5 22.1889V22.7308C5 26.1932 7.80683 29 11.2692 29H30.3462C32.9164 29 35 26.9164 35 24.3462C35 21.7759 32.9164 19.6923 30.3462 19.6923H27.5758C27.0235 19.6923 26.5758 19.2446 26.5758 18.6923V16.5758C26.5758 12.9441 23.6317 10 20 10H18.7701Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Clouds;
